export const OPEN_FEEDBACK_EVENT = 'imgcloud:open-feedback';

export interface OpenFeedbackEventDetail {
  content?: string;
}

export const openUserFeedback = (detail: OpenFeedbackEventDetail = {}) => {
  window.dispatchEvent(new CustomEvent<OpenFeedbackEventDetail>(OPEN_FEEDBACK_EVENT, { detail }));
};
